module.exports = "<span class=\"btn btn-sm btn-warning\">{{$ctrl.proyecto.estado}}</span>\n<button md-effect type=\"button\" class=\"btn btn-info btn-sm mt-1\"\n  uib-tooltip=\"{{$ctrl.getTooltip()}}\" ng-if=\"$ctrl.puedeCambiarEstado()\" ng-click=\"$ctrl.cambiarEstado()\">\n  <i class=\"fa {{$ctrl.getIcon()}}\"></i>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/estados/button.html
// module id = 717
// module chunks = 0